module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/clip-521608f73890675d029e8feb5668bcff.webp";